import { DocumentInstanceType } from "types/enum";

export const isAttachedFilesBulkDownloadSupported = (docInstanceType: DocumentInstanceType) => {
    return docInstanceType !== DocumentInstanceType.ProposalSnapshot;
};
